import React, { useState } from 'react';
import apiConnect from '../../../config/apiConfig';
import { CustomButton, message } from '../../utils/Utils';
import { SmallModal } from '../../utils/Modals';
import { Col, Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import UploadFile from '../uploadFile/UploadFile';

const ManageUsers = () => {
  const [file, setFile] = useState();
  const [isUpdateUsersModalOpen, setIsUpdateUsersModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const toggleModal = (set, state) => {
    set(!state);
  };

  const saveFile = async () => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('file', file);

      await apiConnect.post('/upload/users?adminUpdate=true', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      message.success('Usuarios actualizados con éxito.');
      setIsUpdateUsersModalOpen(false);
    } catch (error) {
      message.error('Ha ocurrido un error al intentar actualizar los usuarios');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <CustomButton
        color="btnOrange"
        size="bg"
        content={'Actualizar Usuarios'}
        onclick={() => setIsUpdateUsersModalOpen(true)}
      />
      <SmallModal
        title={'Actualizar usuarios'}
        toggle={toggleModal}
        state={isUpdateUsersModalOpen}
        set={setIsUpdateUsersModalOpen}
        destroyOnClose={true}
        howManyBtn="2"
        firstBtn={{
          color: 'btnOrange',
          content: 'Cerrar',
          onclick: () => {
            setIsUpdateUsersModalOpen(false);
          },
        }}
        secondBtn={{
          color: 'btnOutline',
          content: 'Confirmar',
          disabled: isLoading,
          onclick: () => {
            saveFile();
          },
        }}
        content={
          <Row justify="center">
            <Col style={{ marginBottom: '3rem' }}>
              {isLoading ? (
                <>
                  <span>Actualizando usuarios </span>
                  <Spin indicator={antIcon} />
                </>
              ) : (
                <UploadFile setFile={setFile} />
              )}
            </Col>
          </Row>
        }
      />
    </>
  );
};

export default ManageUsers;
